var map = {
	"./decidim/avatar-multiuser.png": 2932,
	"./decidim/brands/facebook.svg": 28858,
	"./decidim/brands/google.svg": 3080,
	"./decidim/brands/twitter-x.svg": 69480,
	"./decidim/cc-badge.png": 22294,
	"./decidim/decidim-logo.svg": 77622,
	"./decidim/default-avatar.svg": 54962,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 8950,
	"./decidim/icons.svg": 49701,
	"./decidim/pattern.png": 81426,
	"./decidim/placeholder-card-g.svg": 70719,
	"./decidim/placeholder-card-l.svg": 13892,
	"./decidim/placeholder.jpg": 13659,
	"./decidim/remixicon.symbol.svg": 92115,
	"./decidim/vendor/social-share-button/douban.svg": 6658,
	"./decidim/vendor/social-share-button/email.svg": 58783,
	"./decidim/vendor/social-share-button/facebook.svg": 53345,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 51763,
	"./decidim/vendor/social-share-button/hacker_news.svg": 40691,
	"./decidim/vendor/social-share-button/linkedin.svg": 82191,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 45640,
	"./decidim/vendor/social-share-button/pinterest.svg": 35473,
	"./decidim/vendor/social-share-button/reddit.svg": 22817,
	"./decidim/vendor/social-share-button/telegram.svg": 66456,
	"./decidim/vendor/social-share-button/tumblr.svg": 50447,
	"./decidim/vendor/social-share-button/twitter.svg": 32814,
	"./decidim/vendor/social-share-button/vkontakte.svg": 86896,
	"./decidim/vendor/social-share-button/wechat.svg": 90715,
	"./decidim/vendor/social-share-button/whatsapp.svg": 91539,
	"./decidim/vendor/social-share-button/x.svg": 29719,
	"./decidim/vendor/social-share-button/xing.svg": 16161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75891;